const translations = {
    dataType: 'Data Type',
    drone: 'Drone',
    sprayType: 'Spray Type',
    timestamp: 'Timestamp',
    type: 'Type'
};

export default translations;
